"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigilOfDamnationAbilityHandler = exports.SigilOfDamnationActorAbilityFactory = exports.SigilOfDamnationAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Passive_SigilOfDamnation_1 = require("../../core/effects/core/Passive_SigilOfDamnation");
const Duration_1 = require("../../core/Duration");
const EffectType_1 = require("../../core/effects/EffectType");
const EventType_1 = require("../../core/events/EventType");
const Schedule_1 = require("../../core/Schedule");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const core_2 = require("../../core/event-handlers/core");
const core_3 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class SigilOfDamnationAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.SigilOfDamnation;
        this.__typeName = "SigilOfDamnation";
    }
}
exports.SigilOfDamnationAbilityArgs = SigilOfDamnationAbilityArgs;
let SigilOfDamnationActorAbilityFactory = class SigilOfDamnationActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("SigilOfDamnation", "OneEnemies", 4);
    }
};
SigilOfDamnationActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("SigilOfDamnation")
], SigilOfDamnationActorAbilityFactory);
exports.SigilOfDamnationActorAbilityFactory = SigilOfDamnationActorAbilityFactory;
let SigilOfDamnationAbilityHandler = class SigilOfDamnationAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            effect: new Passive_SigilOfDamnation_1.Passive_SigilOfDamnationEffectArgs(),
            duration: Duration_1.Duration.Permanent,
            supernatural: true,
        });
    }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        const effects = container.getEffectsOfType(ability.invokerId, EffectType_1.EffectType.Passive_SigilOfDamnation);
        for (const effect of effects) {
            container.cancelEffect(sequence, effect);
        }
        const [selectedEnemy] = ability.args.target.actorIds;
        sequence = sequence.pushSequence("sequential");
        sequence.push(new core_3.AnimateCharacterAbilityVfxStepArgs(ability.invokerId, "SigilOfDamnation", "attacking"));
        container.applyDebuff({
            attackerId: ability.invokerId,
            targetId: selectedEnemy,
            effect: new core_1.LinkedEffectsEffectArgs([
                new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageImmunity, 20),
                new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.DeathDamageImmunity, 20),
            ], true),
            duration: Duration_1.Duration.Turns(4),
            sequence,
            onApplied: (sequence) => {
                sequence.push(new core_3.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(selectedEnemy, "feet", "behind"), "DarkMagicCircle"));
            }
        });
        container.registerEventHandler(ability.invokerId, EventType_1.EventType.Killed, Schedule_1.Schedule.Once(), new core_2.CancelEventHandlersEventHandlerArgs([
            container.registerEventHandler(ability.invokerId, EventType_1.EventType.TurnStarted, Schedule_1.Schedule.Combined(4, 1), new core_2.ApplyEffectEventHandlerArgs(ability.invokerId, Target_1.Target.Self, Duration_1.Duration.Permanent, new Passive_SigilOfDamnation_1.Passive_SigilOfDamnationEffectArgs(), true)),
        ]));
    }
};
SigilOfDamnationAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.SigilOfDamnation)
], SigilOfDamnationAbilityHandler);
exports.SigilOfDamnationAbilityHandler = SigilOfDamnationAbilityHandler;
